export function processNotificationToErp() {
    function sendNotification(href, message) {
        const data = {
            action: "crm-new-message",
            message: message,
            url: href,
        };
        window.parent.postMessage(data, window.erpOrigin);
    }

    function processMessages() {
        $(".js-area-notificacoes a").each(function () {
            let href = $(this).attr("href");
            href = href.replace("eloca.com.br", "otimogestor.com.br");
            href = href.replace("app.", "elocacrm.");
            href = href.replace("develop.", "elocacrmd.");
            href = href.replace("sandbox.", "elocacrms.");
            sendNotification(href, $(this).text().trim());
        });
    }

    function observeMessages() {
        const div = $(".js-area-notificacoes")[0];
        if (!div) return;
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === "childList") processMessages();
            }
        });
        observer.observe(div, {
            childList: true,
            attributes: false,
            characterData: true,
            subtree: true,
        });
    }

    processMessages();
    observeMessages();
}
